export const LINK_COPIED_DURATION_MS = 1_500;

export const EMPTY_MEMBERS = [];

export const MESSAGE_ROW_CLASS_NAME = 'teamChatMessageRow';

export const UNKNOWN_SENDER_LABEL = 'Unknown';
